import React, { useContext, useEffect, useRef, useState } from 'react';

import { Form, InputRef } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { RetrieveUserGroupSchema } from '@app/models/users';

import { EditableContext } from '../EditableContext';

import { Input } from './styles';

interface IProps {
  title: React.ReactNode;
  editable: boolean;
  required?: boolean;
  children: React.ReactNode;
  dataIndex: keyof RetrieveUserGroupSchema;
  record: RetrieveUserGroupSchema;
  dataSource: RetrieveUserGroupSchema[];
}

export const EditableCell: React.FC<IProps> = ({
  title,
  editable,
  required,
  children,
  dataIndex,
  record,
  dataSource,
  ...restProps
}) => {
  void title;
  void record;
  void dataSource;
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext);
  const validationT = useTranslation(NSKeys.validation);

  useEffect(() => {
    setEditing(Boolean(editable));
  }, [editable]);

  useEffect(() => {
    if (editing) {
      inputRef?.current?.focus();
    }
  }, [editing]);

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={
          required
            ? [
                {
                  required: true,
                  message: validationT.t('required'),
                },
              ]
            : undefined
        }>
        <Input ref={inputRef} onPressEnter={() => form?.submit()} />
      </Form.Item>
    ) : (
      <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }}>
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
